import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { YOUTUBE_VIDEO_BASE_CLASSNAME } from './Constants';
import { createYoutubeVideo } from './YoutubeVideo';
createComponents(".".concat(YOUTUBE_VIDEO_BASE_CLASSNAME), createYoutubeVideo, NO_PATTERN_BUSINESS_LOGIC);
